export function sha256Frag(sha) {
    if (!sha)
        return '—';
    return sha.length > 14 ? `${sha.slice(0, 6)}…${sha.slice(-4)}` : sha;
}
